import highlight from '@mdx-deck/themes/syntax-highlighter-prism';
import Slide from "../../../../src/templates/slide";
import ImageSlide from "../../../../src/templates/image-slide";
import CodeBlock from "../../../../src/components/site-chrome/code-figure";
import AccessibleAnimationDemo from "../../../../src/components/better/animation";
import Autocomplete from "../../../../src/components/better/downshift-autocomplete";
import baseTheme from "../../../../src/theme";
import React from 'react';
export default {
  highlight,
  Slide,
  ImageSlide,
  CodeBlock,
  AccessibleAnimationDemo,
  Autocomplete,
  baseTheme,
  React
};